// extracted by mini-css-extract-plugin
module.exports = {"root":"ReferralForm_root__SBwHq"};